<template>
  <Page :title="pageTitle" :sub-title="pageSubTitle" id="company" :class="{ 'has-prequal-form': showPrequalForm }">
    <div v-if="isLoading" class="company-loading" aria-live="polite">
      <LoadingIndicator message="Loading company information…" />
    </div>
    <template v-if="company">
      <div v-if="showPrequalForm">
        <iframe :src="prequalFormUrl" id="prequalForm" />
      </div>
      <div v-else>
        <Form @saved="handleSaved" />
      </div>
    </template>
  </Page>
</template>

<script setup lang="ts">

import Page from "@/components/Page.vue";
import LoadingIndicator from '@/components/LoadingIndicator.vue';
import Form from "./Form.vue";
import {NotificationError} from "@/internal";
import {storeToRefs} from "pinia";
import {computed, onMounted} from "vue";
import {useCompanyStore} from "@/stores/CompanyStore";
import {useCompanyUpdateStore} from "@/stores/CompanyUpdateStore";

const companyStore = useCompanyStore();
const companyUpdateStore = useCompanyUpdateStore();
const {company, isLoading} = storeToRefs(companyStore);

const client = computed(() => company.value?.client);

const prequalFormUrl = computed(() => company.value?.prequal_url || '');
const showPrequalForm = computed(() => Boolean(prequalFormUrl.value && company.value?.prequal_url && client.value?.prequal_activated && client.value?.use_prequal_on_portal && client.value?.portal_prequal_form_id));

const pageTitle = computed(() => (showPrequalForm.value) ? false : 'Update My Info');
const pageSubTitle = computed(() => (showPrequalForm.value) ? '' : company.value?.name || '');

onMounted(() => {
  handleSaved();
});

function handleSaved() {
  loadCompany();
  loadCompanyUpdates();
}

function loadCompany() {
  const payload = {
    params: {
      include: [
        'client.latestTerms',
        'primaryContact',
        'trades',
      ],
    }
  };

  companyStore.getCompany(payload)
    .catch(error => {
      if (error.errors) {
        NotificationError({}, error);
      } else {
        NotificationError({
          message: error,
        });
      }
    });
}

function loadCompanyUpdates() {
  const payload = {
    params: {
      include: [
      ],
    }
  };

  companyUpdateStore.index(payload)
    .catch(error => {
      if (error.errors) {
        NotificationError({}, error);
      } else {
        NotificationError({
          message: error,
        });
      }
    });
}

</script>

<style scoped lang="scss">

#company {
  position: relative;

  .company-loading {
    align-items: center;
    background: rgba($white, .8);
    display: flex;
    inset: 0;
    justify-content: center;
    position: absolute;
    z-index: 2;
  }
}
#prequalForm{
  width: 100%;
  height: calc(100vh - 70px);
  box-sizing: border-box;
}



</style>
<style lang="scss">
.the-page.has-prequal-form {
  .page-container {
    padding: 0;
  }
}

.app:has(.the-page.has-prequal-form) {
  .app-footer {
    margin-top: 0;
  }
}
</style>
